import { useRef, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useOnClickOutside } from '../../hooks/useOnClickOutside';
import { LogoIcon, UserIcon } from '../shared/Icons/index';
import { RootState } from '../../redux/store';
import './Layout.scss';

export const Layout = () => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLDivElement>(null);
  //const { decodedToken } = useSelector((state: RootState) => state.auth);
  const selectAuth = (s: RootState) => {
    const t = s.auth.decodedToken;
    return { ...t, userTypeNum: Number(t?.userType) };
  };
  const { userTypeNum } = useSelector(selectAuth);
  const isSSO = userTypeNum === 3;
  console.log(userTypeNum);
  if (isSSO) {
    console.log(isSSO)
  }

  const onOutsideHeaderClickHandler = () => {
    setIsActive(false);
  };

  useOnClickOutside(dropdownRef, onOutsideHeaderClickHandler);

  return (
    <>
      <header className='header'>
        <div className='menu'>
          <LogoIcon />
        </div>
        {!isSSO && (
        <div className='content'>
          <div className='container' ref={dropdownRef}>
            <UserIcon onClick={() => setIsActive(!isActive)} className={`${isActive ? 'profile-icon active' : ''}`} />
          </div>
        </div>
        )}
          <div className={`collapse-menu ${isActive ? 'active' : ''}`}>
          <button className='button-logout' type='button' disabled={false} onClick={() => navigate('/logout')}>
            Logout
          </button>
        </div>

      </header>

      <main className='main'>
        <div className='outlet'>
          <Outlet />
        </div>
      </main>
    </>
  );
};
